import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import type { SxProps } from '@mui/material';
import { FormLabel, Stack, Typography, useTheme } from '@mui/material';

import IconWithTooltip from '../../../../../shared/IconWithTooltip/IconWithTooltip';
import RichText from '../RichText/RichText';

type RichTextFieldProps = {
  label?: string;
  tooltip?: string;
  required?: boolean;
  validationState?: 'none' | 'error';
  validationMessage?: string;
  showValidationMessageIcon?: boolean;
  value?: string;
  onChange: (value: string) => void;
  formMode?: 'edit' | 'preview' | 'readonly' | 'new';
  sx?: SxProps;
};

export const RichTextField = ({
  label,
  tooltip,
  required,
  validationState = 'none',
  validationMessage,
  showValidationMessageIcon,
  value,
  onChange,
  formMode,
  sx,
}: RichTextFieldProps) => {
  const theme = useTheme();

  return (
    <Stack direction="column" spacing={1} sx={{ width: '100%' }}>
      <Stack direction="column" spacing={1}>
        <FormLabel>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
            <Typography variant="body2" color={theme.palette.text.primary}>
              {label}
            </Typography>
            {tooltip && <IconWithTooltip tooltipTitle={tooltip} icon={<InfoOutlinedIcon />} />}
            {required && (
              <Typography variant="caption" color={theme.palette.error.light}>
                *
              </Typography>
            )}
          </Stack>
        </FormLabel>
        <RichText value={value} onChange={onChange} formMode={formMode} sx={sx} />
      </Stack>
      {validationState === 'error' && validationMessage && (
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          {showValidationMessageIcon && <ErrorOutlineIcon color="error" fontSize="small" />}
          <Typography variant="caption" color={theme.palette.error.main}>
            {validationMessage}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};

export default RichTextField;
